import { useContext } from 'react';
import { AuthContext } from '../context/firebaseContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
